const FETCH_OWN_RIGHTS = 'FETCH_OWN_RIGHTS';
export default FETCH_OWN_RIGHTS;
